"use client";

import { Stack, StackProps } from "@chakra-ui/react";

interface PageProps extends StackProps {}

export function Page({ children, ...props }: PageProps) {
  return (
    <Stack gap="0" p="0" m="0" {...props}>
      {children}
    </Stack>
  );
}
